import { useBriefingZones } from './useBriefingZones';
import { useNowcastZones } from './useNowcastZones';
import { useFeatureAccess } from './useFeatureAccess';

/**
 * Concelho slugs the current user may open in the municipal console.
 *
 * The console merges what were two separate surfaces (briefing = today's risk,
 * nowcast = live fires), and their grants are independent: a customer can hold one
 * without the other. So the gate is the UNION, and the page hides whichever panel the
 * user has no grant for rather than refusing the whole concelho.
 *
 * `nowcast_admin` (owner view) unlocks every concelho, mirroring /ignis/nowcast.
 *
 * As everywhere else in this app, this is a rendering decision, not a security
 * boundary: the RPCs and RLS are.
 */
export function useMunicipioZones() {
  const { zones: briefing, loading: bLoading } = useBriefingZones();
  const { zones: nowcast, loading: nLoading } = useNowcastZones();
  const { access: isAdmin, loading: aLoading } = useFeatureAccess('nowcast_admin');

  const loading = bLoading || nLoading || aLoading;
  const zones = loading
    ? null
    : Array.from(new Set([...(briefing ?? []), ...(nowcast ?? [])])).sort();

  return {
    zones,
    loading,
    isAdmin: Boolean(isAdmin),
    hasBriefing: (slug: string) => (briefing ?? []).includes(slug),
    hasNowcast: (slug: string) => (nowcast ?? []).includes(slug),
  };
}
